import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_permissions';
export const useUserPermissionsTranslation = () => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    toast_success: 'Доступы пользователя успешно обновлены',
    toast_error: 'Не удалось обновить доступы пользователя',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    toast_success: 'User permissions updated successfully',
    toast_error: 'Failed to update user permissions',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    toast_success: 'Permisos de usuario actualizados correctamente',
    toast_error: 'Error al actualizar los permisos de usuario',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    toast_success: 'Permissões do usuário atualizadas com sucesso',
    toast_error: 'Falha ao atualizar as permissões do usuário',
  },
}) : {}) as Record<string, unknown>;
